export const columnsDataStudies = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Descripción",
    accessor: "description",
  },
  {
    Header: "Tipo de estudio",
    accessor: "studyTypeDescription",
  },
];
